
(function (window, document, jQuery, undefined) {

    var $ = jQuery.noConflict();
    var $buttons = $(".personio-jobs-list__dropdown .dropdown-item[type=button]");
    var $buttonToggle = $(".personio-jobs-list__dropdown .dropdown-toggle");
    var $cards = $(".personio-job-card");
    var $personioJobsListCards = $('.personio-jobs-list__cards');
    var $cardWrapper = $(".personio-jobs-list__card-wrapper");
    var $cardLoader = $(".personio-jobs-list__card-loader");

    $buttons.click(function () {
        var dataShow = $(this).data("show");
        var visibleIds = $.isNumeric(dataShow) ?  [dataShow] : dataShow.split(',');
        $cards.hide();
        $.each(visibleIds, function () {
            $("#personio-job-card-" + this).show();
        });
        $buttonToggle.html($(this).html());

        // disable load more if not all
        var isAll = $(this).is(":first-child");
        if (isAll) {
            // reset card load more feature
            $cardWrapper.removeClass("d-none");
            $cardWrapper.each(function () {
                if ($(this).data('index') >= 6) {
                    $(this).addClass("d-none");
                }
            });
            if ($cardLoader.length > 0) {
                $cardLoader.removeClass('d-none');
                $cardLoader.addClass('d-flex');
                $(".don-btn-load-more__counter").text($personioJobsListCards.data("counter"));
            }
        } else {
            // show all, hide load more
            $cardWrapper.removeClass("d-none");
            if ($cardLoader.length > 0) {
                $cardLoader.addClass('d-none');
                $cardLoader.removeClass('d-flex');
            }
        }
    });

    // show more btn click handler
    $personioJobsListCards.find('.don-btn-load-more').on('click', function () {

        // show next teasers
        var rowId = $(this).data('for');
        var more = $(this).data('more');
        var $myTeasersToAdd = $('#' + rowId)
            .children('.d-none')
            .slice(0, more);
        $myTeasersToAdd.removeClass('d-none');

        // change teasers left counter
        var $counter = $(this).children('span').first();
        var currentCount = $counter.text();
        var newCount = currentCount - more;
        if (newCount <= 0) {
            $(this).parent().removeClass('d-flex');
            $(this).parent().addClass('d-none');
        } else {
            $counter.text(newCount);
        }
    });

})(window, document, jQuery);
